class ProductInventory extends HTMLElement {
  constructor() {
    super();
    window.initLazyScript(this, this.initLazySection.bind(this));
  }

  initLazySection() {
    this.inventoryNotice = this.querySelector('.js-inventory-notice');
    this.variantInventory = this.getVariantInventory();

    // Dynamically fetch customer type and assigned inventory
    this.updateCustomerData();

    const productInfo = this.closest('.product-info');
    const form = this.closest('form');

    if (productInfo) {
      const variantPicker = productInfo.querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }
    }

    // Ensure the correct inventory is displayed on initial page load
    if (form) {
      const defaultVariantId = parseInt(form.querySelector('[name="id"]').value, 10);
      if (!isNaN(defaultVariantId)) {
        console.log('Initial page load, default variant ID:', defaultVariantId);
        this.updateInventoryForVariant(defaultVariantId);
      } else {
        console.warn('No default variant ID found on initial page load.');
      }
    } else {
      console.warn('No form element found for product on initial page load.');
    }
  }

  updateCustomerData() {
    // Dynamically fetch data attributes
    this.customerType = this.dataset.customerType || 'b2c';
    this.assignedInventory = this.dataset.assignedInventory || null;

    console.log('Customer type on update:', this.customerType);
    console.log('Assigned inventory on update:', this.assignedInventory);
  }

  getVariantInventory() {
    const dataEl = this.querySelector('script[type="application/json"]');
    try {
      const inventoryData = JSON.parse(dataEl.textContent);
      console.log('Parsed Variant Inventory:', inventoryData);
      return inventoryData;
    } catch (e) {
      console.error('Error parsing variant inventory JSON:', e);
      return [];
    }
  }

  handleVariantChange(evt) {
    if (evt.detail && evt.detail.variant) {
      const variantId = evt.detail.variant.id;
      console.log('Variant changed, ID:', variantId);

      // Refresh customer data dynamically on variant change
      this.updateCustomerData();

      this.updateInventoryForVariant(variantId);
    } else {
      console.warn('No valid variant in event details.');
      this.resetInventoryMessage();
    }
  }

  updateInventoryForVariant(variantId) {
    const variant = this.variantInventory.find(v => v.id === variantId);

    if (!variant) {
      console.warn('Variant not found in inventory data:', variantId);
      this.resetInventoryMessage();
      return;
    }

    console.log('Variant data found:', variant);

    let inventoryQuantity = 0;

    if (this.customerType === 'b2b') {
      // Ensure B2B inventory is dynamically updated
      this.assignedInventory = this.dataset.assignedInventory;
      inventoryQuantity = this.getInventoryForAssignedLocation(variant);
      console.log(
        `Inventory quantity for B2B (location: ${this.assignedInventory}):`,
        inventoryQuantity
      );
    } else {
      // Apply B2C inventory logic directly using Oslo inventory
      inventoryQuantity = variant.oslo || variant.inventory_quantity || 0;
      console.log('Inventory quantity for B2C (Oslo):', inventoryQuantity);
    }

    this.displayInventoryMessage(inventoryQuantity);
  }

  getInventoryForAssignedLocation(variant) {
    let inventory = 0;

    switch (this.assignedInventory) {
      case "1":
        inventory = variant.fredrikstad || 0;
        break;
      case "2":
        inventory = variant.trondheim || 0;
        break;
      case "3":
        inventory = variant.oslo || 0;
        break;
      default:
        console.warn(
          'Invalid or missing assigned inventory location:',
          this.assignedInventory
        );
    }

    console.log(
      `Computed inventory for assigned location (${this.assignedInventory}): ${inventory}`
    );

    return inventory;
  }

  displayInventoryMessage(count) {
    if (count > 0) {
      this.inventoryNotice.innerText = `${count} på nettlager`;
    } else {
      this.inventoryNotice.innerText = "Estimert 7-10 dager fra leverandør";
    }
    this.inventoryNotice.hidden = false;
  }

  resetInventoryMessage() {
    console.warn('Resetting inventory message to default.');
    this.inventoryNotice.innerText = "Estimert 7-10 dager fra leverandør";
    this.inventoryNotice.hidden = false; // Always ensure visibility
  }
}

customElements.define('product-inventory', ProductInventory);
